import React, { useState } from "react";

const FAQ_ITEMS = [
  {
    q: "ASAP Hub remplace-t-il nos outils existants ?",
    a: "L'objectif est surtout de centraliser et fluidifier les informations critiques autour des profils, compétences, opportunités et partenaires. Le positionnement peut compléter votre organisation existante.",
  },
  {
    q: "L'IA prend-elle des décisions à la place des équipes ?",
    a: "Non. L'IA sert d'assistant pour analyser, synthétiser, rapprocher et préparer. La décision reste humaine, en particulier sur la qualification commerciale et le choix final des profils.",
  },
  {
    q: "Pour quelles structures est-ce pertinent ?",
    a: "La plateforme vise les ESN, cabinets de conseil et organisations qui doivent valoriser rapidement des compétences, des CV, des profils internes et un réseau de partenaires.",
  },
  {
    q: "Peut-on déployer module par module ?",
    a: "Oui, la logique présentée est modulaire : Profile, Partners, Skills, Pilot et CV peuvent être mis en avant selon la maturité et les priorités de votre équipe.",
  },
  {
    q: "Comment garantissez-vous la sécurité des données ?",
    a: "La plateforme est conforme RGPD. Les accès sont gérés finement par Business Unit et par rôle, et les données sensibles ne sont pas exposées hors de votre tenant.",
  },
  {
    q: "Comment sont définis vos tarifs ?",
    a: "Nos tarifs s'adaptent à la taille et aux spécificités de votre structure. Les offres Custom sont disponibles sur devis selon votre volume d'activité.",
  },
];

const Faq = () => {
  const [openSet, setOpenSet] = useState(() => new Set([0]));

  const toggle = (idx) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  return (
    <section className="mk-section soft" id="faq" data-testid="section-faq">
      <div className="mk-wrap">
        <div className="mk-section-head mk-reveal">
          <div>
            <h2>Questions fréquentes</h2>
          </div>
        </div>
        <div className="mk-faq">
          {FAQ_ITEMS.map((item, idx) => {
            const isOpen = openSet.has(idx);
            return (
              <div key={item.q} className={`mk-faq-item mk-reveal${isOpen ? " open" : ""}`}>
                <button
                  type="button"
                  className="mk-faq-q"
                  aria-expanded={isOpen}
                  onClick={() => toggle(idx)}
                >
                  {item.q}
                  <span className="mk-faq-toggle" aria-hidden="true">{isOpen ? "−" : "+"}</span>
                </button>
                <div className="mk-faq-a">
                  <p>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
